import {
    keyframes,
    styled,
} from '../../../../stitches/config'

import React from 'react'

import {useTranslation} from 'react-i18next'


const writing = keyframes({
    '0%': {
        animationTimingFunction: 'cubic-bezier(0,0.5,0.5,1)',
        top: 8,
    },
    '100%': {top: 8},
    '30%': {
        animationTimingFunction: 'cubic-bezier(0.5,0,1,0.5)',
        top: 0,
    },
    '60%': {
        animationTimingFunction: 'cubicBezier(0.5,0.5,0.5,0.5)',
        top: 8,
    },
})

const StyledWritingContainer = styled('div', {paddingLeft: 2})

const StyledWriting = styled('div', {
    backfaceVisibility: 'hidden',
    background: 'none',
    display: 'inline-block',
    height: 15,
    overflow: 'hidden',
    position: 'relative',
    transformOrigin: '0 0',
    width: 25,
})

const StyledBall = styled('div', {
    animation: `${writing} 1s infinite`,
    borderRadius: '50%',
    boxSizing: 'content-box',
    height: 6,
    position: 'absolute',
    width: 6,
})

const Writing = (): React.ReactElement => {
    const {t} = useTranslation()

    return (
        <StyledWritingContainer>
            <StyledWriting aria-label={t('User is typing...')} role='status'>
                <StyledBall style={{
                    animationDelay: '-0.6s',
                    backgroundColor: '#252525',
                    left: '0',
                }}
                />
                <StyledBall style={{
                    animationDelay: '-0.39999999999999997s',
                    backgroundColor: '#252525',
                    left: '8px',
                }}
                />
                <StyledBall style={{
                    animationDelay: '-0.19999999999999998s',
                    backgroundColor: '#252525',
                    left: '16px',
                }}
                />
            </StyledWriting>
        </StyledWritingContainer>
    )
}

export default Writing
